/* Page to sign the user up */
import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import door from "../../assets/door.png"
import rightdoor from "../../assets/rightdoor.png"
import styles from "../../styles/SignInUpForm.module.css"
import btnStyles from "../../styles/Button.module.css"

import Form from "react-bootstrap/Form"
import Alert from "react-bootstrap/Alert"
import Button from "react-bootstrap/Button"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import Image from "react-bootstrap/Image"
import Container from "react-bootstrap/Container"
import { useRedirectSign } from "../../hooks/RedirectSign"
import { axiosInstanceNoAuth } from "../../api/axiosDefaults"
import TopBoxSign from "../../components/TopBoxSign"

const SignUpForm = () => {
  useRedirectSign()
  const [signUpData, setSignUpData] = useState({
    username: "",
    password1: "",
    password2: "",
    email: "",
  })

  const { username, password1, password2, email } = signUpData

  const [errors, setErrors] = useState({})

  const history = useHistory()

  const handleChange = (event) => {
    setSignUpData({
      ...signUpData,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    // console.log("signup data: ", signUpData)

    try {
      // TODO: remove
      await axiosInstanceNoAuth.post("/dj-rest-auth/registration/", signUpData)
      history.push("/signin")
    } catch (err) {
      setErrors(err.response?.data)
    }
  }

  return (
    <Container className={styles.SignupBox}>
      <TopBoxSign title="Sign Up" />
      <Row className={styles.Row}>
        <Col className="my-3 text-center pr-0 pr-md-3" xs={1} md={1}>
          <Image className={`${styles.FillerImagel}`} src={door} />
        </Col>
        <Col className="my-auto py-2 p-md-2" xs={10}>
          <Row>
            <Col md={3} className="d-nome d-md-block"></Col>
            <Col xs={12} md={6}>
              <Container>
                <h1 className={styles.Header}>sign up</h1>
                <Form onSubmit={handleSubmit} className={styles.Form}>
                  <Form.Group controlId="username" className="mb-2">
                    <Form.Label className="d-none">Username</Form.Label>
                    <Form.Control
                      className={styles.Input}
                      type="text"
                      placeholder="Username"
                      name="username"
                      value={username}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  {errors.username?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}
                  <Form.Group controlId="email" className="mb-2">
                    <Form.Label className="d-none">Email</Form.Label>
                    <Form.Control
                      className={styles.Input}
                      type="text"
                      placeholder="Email"
                      name="email"
                      value={email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  {errors.email?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}

                  <Form.Group controlId="password1" className="mb-2">
                    <Form.Label className="d-none">Password</Form.Label>
                    <Form.Control
                      className={styles.Input}
                      type="password"
                      placeholder="Password"
                      name="password1"
                      value={password1}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  {errors.password1?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}

                  <Form.Group controlId="password2" className="mb-2">
                    <Form.Label className="d-none">Confirm Password</Form.Label>
                    <Form.Control
                      className={styles.Input}
                      type="password"
                      placeholder="Confirm Password"
                      name="password2"
                      value={password2}
                      onChange={handleChange}
                    />
                  </Form.Group>
                  {errors.password2?.map((message, idx) => (
                    <Alert variant="warning" key={idx}>
                      {message}
                    </Alert>
                  ))}

                  {/* <Form.Group controlId="key" className="mb-2">
                    <Form.Label className="d-none" >Enter Key</Form.Label>
                    <Form.Control 
                      className={styles.Input}
                      type="key" placeholder="Enter Key"
                      name="key" 
                      value={key}
                      onChange={handleChange}
                      />
                </Form.Group>
                {errors.key?.map((message, idx) => (
                  <Alert variant="warning" key={idx}>
                    {message}
                  </Alert>
                ))} */}

                  <div className="text-center">
                    <Button
                      className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Bright}`}
                      type="submit"
                    >
                      Sign up
                    </Button>
                  </div>
                  {errors.non_field_errors?.map((message, idx) => (
                    <Alert key={idx} variant="warning" className="mt-3">
                      {message}
                    </Alert>
                  ))}
                </Form>
              </Container>
            </Col>
          </Row>
          <Container className="mt-3">
            <Link className={styles.Link} to="/signin">
              Already have an account? <span>Sign in</span>
            </Link>
          </Container>
        </Col>
        <Col className={`my-3 text-center pl-0 pl-md-3`} xs={1} md={1}>
          <Image className={`${styles.FillerImagel}`} src={rightdoor} />
        </Col>
      </Row>
    </Container>
  )
}

export default SignUpForm
